export const environment = {
    hmr: false,
    production: true,
    version: '3.5.2.202',
};
